import { Component, OnDestroy, OnInit } from '@angular/core';
import { MaterialModule } from '../../../material.module';
import { CommonModule, DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS, provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NgxEditorComponent, NgxEditorMenuComponent, Editor, Toolbar } from 'ngx-editor';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TextMaskDateDirective } from '../../../Directives/text-mask-date-directive.directive';
import moment from 'moment';
import { Router } from '@angular/router';
import { NoteService } from '../notesofaccounts/note.service';
import { CharitiesService } from '../charities/services/charities.service';
import Swal from 'sweetalert2';
import { CustomDateAdapter } from '../../../Shared/common/ng-date-parse-adapter';
import { MatSelectChange } from '@angular/material/select';
import { CharityDataShareServiceService } from '../charities/services/charity-data-share-service.service';
import { NotesDatashareService } from '../notes/services/notes-datashare.service';
import { RolesModel } from '../../../Data/Models/Users/roles-model';
import { UsermanagementService } from '../../../services/apps/usermanagement/usermanagement.service';
import { MatRadioChange } from '@angular/material/radio';
import { MessageServiceService } from '../../../Shared/common/message-service.service';


@Component({
  selector: 'app-independent-examiner-report',
  imports: [MaterialModule, TablerIconsModule, MatDatepickerModule, NgxEditorComponent, NgxEditorMenuComponent, CommonModule, ReactiveFormsModule, TextMaskDateDirective],
  templateUrl: './independent-examiner-report.component.html',
  styleUrl: './independent-examiner-report.component.scss',
  providers: [{ provide: DateAdapter, useClass: CustomDateAdapter },
  { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS }, DatePipe],


})

export class IndependentExaminerReportComponent implements OnInit, OnDestroy {
  form: FormGroup;
  editor: Editor;
  editor2: Editor;
  editor3: Editor;
  charityID: any | number | null;
  currentPeriod: any | null;
  ProfessionalAdvisorsDetails: any = [];
  ProfessionalAdvisorsDetails_count: number = 0;
  filteredAdvisors1: any = [];
  AccountPeriodGrid: any;
  charityName: any = null;
  endDate: any;
  BasicInformation: any;
  isdirty: any;
  accountBodyValue: any;
  CharithDetails: any;
  apFinalised: boolean = false
  isSelected: string = '';
  SubmissionStatus: any;

  constructor(private service: NoteService, private router: Router, private Charity_Service: CharitiesService,
    private datashare: NotesDatashareService, public Charities_Service: CharitiesService, private _UsermanagementService: UsermanagementService,
    private dataShareService: CharityDataShareServiceService, private sharedService: CharityDataShareServiceService, private msgService: MessageServiceService) {
    
   
  }

  ngOnInit(): void {
   // this.dataShareService.updateAccountReportType('Independent Examiner');
    this.sharedService.finalStatus$.subscribe((value: any) => {
      this.apFinalised = value != '' && value == 'Completed'
      if (this.apFinalised) {
        this.form.get('examinerName')?.disable()
        this.form.get('approvalDate')?.disable()
        this.form.get('accountingBody')?.disable()
      }
      else {
        
      }
      this.SubmissionStatus = localStorage.getItem('SubmissionStatus');
    })
    this.charityID = localStorage.getItem('currentCharityID') != '' ? localStorage.getItem('currentCharityID') : 0
    this.currentPeriod = localStorage.getItem('currentPeriod')
    this.Getbasicinformation()
    this.GetUserAccess();
    this.createform();


 
    this.GetProfessionalAdvisorsDetails();
    this.editor = new Editor();
    //this.GetIndependentExaminerDetails();
    this.datashare.isdirty$.subscribe(value => {
      this.isdirty = value
    })
    this.editor2 = new Editor();
    this.editor3 = new Editor();
  }


  UserRoleAccess: RolesModel;
  GetUserAccess() {
    this._UsermanagementService.GetUserRoleAccess(localStorage['userID']).subscribe(data => {
      if (data.entity.length) {
        this.UserRoleAccess = data.entity[0]
      }
    });
  }


  onTrusteeChange(event: MatSelectChange, type?: any): void {
    debugger
    const selectedTrusteeId = event.value;
    var selectedTrustee: any
    if ((selectedTrusteeId && type == 'selected')) {
      this.form.get('examinerName')?.setErrors(null)
      //selectedTrustee = this.trusteesList.find((t: any) => t.trustee_Id === selectedTrusteeId);
      this.form.patchValue({
        trusteeName: selectedTrustee.name
      });
    } else {
      if (this.form.get('examinerName')?.getRawValue() == 0) {
        this.form.get('examinerName')?.setErrors({ required: true })
      }
    }

  }
  ischecked: boolean = false
  createform() {
    this.form = new FormGroup({
      independentExaminerReportId: new FormControl(0),  
      reportDescription: new FormControl('', [
        Validators.required
      ]),
      responsibilitiesDescription: new FormControl('', [
        Validators.required
      ]),
      independentDescription: new FormControl('', [
        Validators.required
      ]),

      matter_of_Concern: new FormControl(this.ischecked),
      examinerName: new FormControl(''),
      approvalDate: new FormControl(null),
      accountingBody: new FormControl('Other/None'),
      CharityID: new FormControl(this.charityID),
      FinancialPeriodsID: new FormControl(this.currentPeriod),
      CreatedDate: new FormControl(new Date()),
      Createdby: new FormControl(101),
      Modifiedby: new FormControl(101),
      ModifiedDate: new FormControl(new Date()),
      CentralUserId: new FormControl(101),
      UserId: new FormControl(101)
    });
    //this.form.get('reportDescription')?.valueChanges.subscribe(value => {
    //  //  alert('')
    //  debugger
    //  //const plainText = value?.replace(/<[^>]*>/g, '') || '';
    //  const plainText = value
    //  if (plainText.length > 2500) {
    //    const trimmedText = plainText.substring(0, 2500);
    //    const safeHtml = trimmedText
    //    this.form.get('reportDescription')?.setValue(safeHtml, { emitEvent: false });
    //  }
    //});


    this.form.get('reportDescription')?.valueChanges.subscribe(value => {
      if (!value) return;

      const plainText = value.replace(/<[^>]*>/g, '');
      const decodedText = decodeHtmlEntities(plainText);

      if (decodedText.length > 2500) {
        const trimmedText = decodedText.substring(0, 2500);
        this.form.get('reportDescription')?.setValue(trimmedText, { emitEvent: false });
      }
    });
    this.form.get('independentDescription')?.valueChanges.subscribe(value => {
      if (!value) return;

      const plainText = value.replace(/<[^>]*>/g, '');
      const decodedText = decodeHtmlEntities(plainText);

      if (decodedText.length > 2500) {
        const trimmedText = decodedText.substring(0, 2500);
        this.form.get('independentDescription')?.setValue(trimmedText, { emitEvent: false });
      }
    });
    this.form.get('responsibilitiesDescription')?.valueChanges.subscribe(value => {
      if (!value) return;

      const plainText = value.replace(/<[^>]*>/g, '');
      const decodedText = decodeHtmlEntities(plainText);

      if (decodedText.length > 2500) {
        const trimmedText = decodedText.substring(0, 2500);
        this.form.get('responsibilitiesDescription')?.setValue(trimmedText, { emitEvent: false });
      }
    });

    function decodeHtmlEntities(text: string): string {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = text;
      return textarea.value;
    }   

  }
  MarkDirty() {
    debugger
    this.datashare.setisdirty(true)
    this.isdirty = true
  }
  limitHtmlContent(html: string, maxLength: number = 2500): string {
    const div = document.createElement('div');
    div.innerHTML = html;

    let charCount = 0;
    const walker = document.createTreeWalker(div, NodeFilter.SHOW_TEXT, null);
    const nodesToRemove: Node[] = [];

    while (walker.nextNode()) {
      const node = walker.currentNode as Text;
      const remaining = maxLength - charCount;

      if (remaining <= 0) {
        nodesToRemove.push(node);
      } else if (node.nodeValue!.length > remaining) {
        node.nodeValue = node.nodeValue!.substring(0, remaining);
        charCount = maxLength;
      } else {
        charCount += node.nodeValue!.length;
      }
    }

    // Remove extra text nodes
    nodesToRemove.forEach(node => node.parentNode?.removeChild(node));

    // Remove empty elements left behind
    const cleanEmptyElements = (element: HTMLElement) => {
      Array.from(element.children).forEach(child => {
        cleanEmptyElements(child as HTMLElement);
        if (
          child.childNodes.length === 0 ||
          (child.childNodes.length === 1 && child.childNodes[0].nodeType === Node.TEXT_NODE && !(child.textContent || '').trim())
        ) {
          child.remove();
        }
      });
    };

    cleanEmptyElements(div);

    return div.innerHTML;
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }


  Getbasicinformation() {
    debugger

    const period = localStorage.getItem('currentPeriod');
    const charityId = localStorage.getItem('currentCharityID');
    this.Charities_Service.Getbasicinfo(charityId, period).subscribe((data: any) => { 
      debugger
      this.BasicInformation = data
      this.endDate = moment(data[0].current_AP_End_Date).format('DD/MM/YYYY');
       this.GetCharityDetails()
    })
  }


  SaveExaminer(): void {
    debugger;
    /*  if (this.isEditorEmpty()) {
        this.form.get('reportDescription')?.setErrors({ required: true });
        this.form.get('reportDescription')?.markAsTouched();
        return;
      }*/
    // Get the value from the form control
    let description: string = this.form.controls['responsibilitiesDescription'].value;

    // Replace all <br> with <br/>
    description = description.replace(/<br\s*>/g, '<br/>');

    // If you want to update the form control back
    this.form.controls['responsibilitiesDescription'].setValue(description);

    if (this.form.controls['reportDescription'].value == '<p></p>' || this.form.controls['reportDescription'].value == "") {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0  f-w-400 text-black" > Opening Statement is required</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "OK",
        showCancelButton: false,
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          return true
        } else {
          return false
        }
      })
    }
    else if (this.form.controls['responsibilitiesDescription'].value == '<p></p>' || this.form.controls['responsibilitiesDescription'].value == "") {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0  f-w-400 text-black" > Responsibilities and basis of report is required</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "OK",
        showCancelButton: false,
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          return true
        } else {
          return false
        }
      })

    } else if (this.form.controls['independentDescription'].value == '<p></p>' || this.form.controls['independentDescription'].value == "") {
      Swal.fire({
        html: `
        <h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5>
        <p class="f-s-14 p-0 f-w-400 text-black">Independent examiner's statement is required</p>
    `,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "OK",
        showCancelButton: false,
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          return true
        } else {
          return false
        }
      })
    }
    else {
    this.CurrentDate_Validate({ target: { value: this.form.get('approvalDate')?.value } });

    if (!this.form.get('examinerName')?.value) {
      this.form.get('examinerName')?.setErrors({ required: true });
      this.form.get('examinerName')?.markAsTouched();
    }

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.form.controls['approvalDate'].setValue(
      this.DbDateConverter(this.form.controls['approvalDate']?.value)
    );

    const payload = {
      independentExaminerReportId: this.form.get('independentExaminerReportId')?.value,
      reportDescription: this.form.get('reportDescription')?.value,
      ResponsibilitiesDescription: this.form.get('responsibilitiesDescription')?.value,
      IndependentDescription: this.form.get('independentDescription')?.value,
      matter_of_Concern: this.ischecked,
      examinerName: this.form.get('examinerName')?.value,
      approvalDate: this.form.get('approvalDate')?.value,
      accountingBody: this.form.get('accountingBody')?.value,
      charityID: this.form.get('CharityID')?.value,
      financialPeriodsID: this.form.get('FinancialPeriodsID')?.value,
      createdDate: this.form.get('CreatedDate')?.value,
      createdby: this.form.get('Createdby')?.value,
      modifiedby: this.form.get('Modifiedby')?.value,
      modifiedDate: this.form.get('ModifiedDate')?.value,
      centralUserId: this.form.get('CentralUserId')?.value,
      userId: this.form.get('UserId')?.value
    };

    this.service.SaveIndependentExaminer(payload).subscribe({
      next: (res) => {
        this.form.markAsPristine();
        this.datashare.setisdirty(false)
        this.isdirty = false
        this.router.navigate(['final-accounts']);
        
      },
      error: (err) => {
        console.error('API error:', err);
        Swal.fire('Error', 'Something went wrong while saving.', 'error');
      }
    });
  }
  }

 


  SetDefault() {
    debugger
    this.form.controls['reportDescription'].setValue(this.defaultStatements)
  }



  DefaultStatement(formControlName: any) {
    debugger
   
      if (this.BasicInformation[0]?.accounting_Method == 'Cash (Receipts & Payments)') {
        this.defaultStatements = {
          //reportDescription: `<p>I report to the trustees on my examination of the accounts of ${this.charityName} (“the Charity”) for the year ended ${this.endDate}. </p>

          //                    <b>Responsibilities and basis of report</b>
          //                    <br/>

          //                    As the charity trustees of the Trust, you are responsible for the preparation of the accounts in accordance with the requirements of the Charities Act 2011 (“the Act”).

          //                    I report in respect of my examination of the Trust’s accounts carried out under section 145 of the 2011 Act and in carrying out my examination, I have followed the applicable Directions given by the Charity Commission under section 145(5)(b) of the Act.
          //                    <br/>

          //                    <b>Independent examiner's statement</b>
          //                    <br/>
          //                    I have completed my examination. I confirm that no material matters have come to my attention (other than that disclosed below *) in connection with the examination which gives me cause to believe that in, any material respect: 
          //                    <ul>
          //                    <li> accounting records were not kept in accordance with section 130 of the Act or </l>
          //                    <li> the accounts do not accord with the accounting records </l>

          //                    </ul>

          //                    <p>I have no concerns and have come across no other matters in connection with the examination to which attention should be drawn in order to enable a proper understanding of the accounts to be reached.</p>`, vamshi
          reportDescription: `<p>I report to the trustees on my examination of the accounts of ${this.charityName} (the Charity) for the year ended ${this.endDate}. </p>`,

          responsibilitiesDescription: `As the charity trustees of the Trust, you are responsible for the preparation of the accounts in accordance with the requirements of the Charities Act 2011 (the Act).<br/>   

                                      I report in respect of my examination of the Trust’s accounts carried out under section 145 of the 2011 Act and in carrying out my examination, I have followed the applicable Directions given by the Charity Commission under section 145(5)(b) of the Act.`,

          independentDescription: `
                            I have completed my examination. I confirm that no material matters have come to my attention (other than that disclosed below *) in connection with the examination which gives me cause to believe that in, any material respect: 
                            <ul>
                            <li> accounting records were not kept in accordance with section 130 of the Act or </li>
                            <li> the accounts do not accord with the accounting records </li>
                            </ul>
                            <p>I have no concerns and have come across no other matters in connection with the examination to which attention should be drawn in order to enable a proper understanding of the accounts to be reached.</p>`,

        }
      }

      else {
        //   alert('oj')
        this.defaultStatements = {
          //reportDescription: `<p>
          //                     I report to the trustees on my examination of the accounts of
          //                     ${this.charityName} (“the Charity”) for the year ended ${this.endDate}.
          //                   </p>

          //                   <h3>Responsibilities and basis of report</h3>
          //                   <p>
          //                     As the charity's trustees, you are responsible for the preparation of the accounts
          //                     in accordance with the requirements of the Charities Act 2011 (“the Act”).
          //                   </p>
          //                   <p>
          //                     I report in respect of my examination of the Trust’s accounts carried out under section 145
          //                     of the 2011 Act and in carrying out my examination, I have followed all the applicable Directions
          //                     given by the Charity Commission under section 145(5)(b) of the Act.
          //                   </p>

          //                   <h3>Independent examiner's statement</h3>
          //                   <p>
          //                     The charity’s gross income exceeded £250,000 and I am qualified to undertake the examination
          //                     by being a qualified member of ${this.accountBodyValue == undefined || this.accountBodyValue == null || this.accountBodyValue == '' ? this.accountBodyValue = 'Other/None' : this.accountBodyValue}.
          //                   </p>
          //                   <p>
          //                     I have completed my examination. I confirm that no material matters have come to my attention
          //                     (other than that disclosed below *) in connection with the examination which gives me cause
          //                     to believe that in, any material respect:
          //                   </p>

          //                   <ul>
          //                   <li>the accounting records were not kept in accordance with section 130 of the Charities Act; or</li>
          //                   <li>the accounts did not accord with the accounting records; or</li>
          //                   <li>the accounts did not comply with the applicable requirements concerning the form and content of accounts set out in the Charities (Accounts and Reports) Regulations 2008 other than any requirement that the accounts give a ‘true and fair’ view which is not a matter considered as part of an independent examination.</li>
          //                   </ul>

          //                   <p>
          //                     I have no concerns and have come across no other matters in connection with the examination
          //                     to which attention should be drawn in order to enable a proper understanding of the accounts
          //                     to be reached.
          //                   </p> `
          reportDescription: `<p>
                             I report to the trustees on my examination of the accounts of
                             ${this.charityName} (the Charity) for the year ended ${this.endDate}.
                           </p>`,
          responsibilitiesDescription:
            `<p>
                             As the charity's trustees, you are responsible for the preparation of the accounts
                             in accordance with the requirements of the Charities Act 2011 (the Act).
                           </p>
                           <p>
                             I report in respect of my examination of the Trust’s accounts carried out under section 145
                             of the 2011 Act and in carrying out my examination, I have followed all the applicable Directions
                             given by the Charity Commission under section 145(5)(b) of the Act.
                           </p> `,
          independentDescription: `<p>
                             The charity’s gross income exceeded £250,000 and I am qualified to undertake the examination
                             by being a qualified member of ${this.accountBodyValue == undefined || this.accountBodyValue == null || this.accountBodyValue == '' ? this.accountBodyValue = 'Other/None' : this.accountBodyValue}.
                           </p>
                           <p>
                             I have completed my examination. I confirm that no material matters have come to my attention
                             (other than that disclosed below *) in connection with the examination which gives me cause
                             to believe that in, any material respect:
                           </p>
 
                           <ul>
                           <li>the accounting records were not kept in accordance with section 130 of the Charities Act; or</li>
                           <li>the accounts did not accord with the accounting records; or</li>
                           <li>the accounts did not comply with the applicable requirements concerning the form and content of accounts set out in the Charities (Accounts and Reports) Regulations 2008 other than any requirement that the accounts give a ‘true and fair’ view which is not a matter considered as part of an independent examination.</li>
                           </ul>
 
                           <p>
                             I have no concerns and have come across no other matters in connection with the examination
                             to which attention should be drawn in order to enable a proper understanding of the accounts
                             to be reached.
                           </p> `


        }
      }
    

    const selected = this.defaultStatements[formControlName];
    if (selected) {
      this.form.patchValue({
        [formControlName]: selected
      },{ emitEvent: false });
    }
    /* this.form.get('examinerName')?.setErrors(null);*/
    
  }
  defaultStatements: { [key: string]: string } = {
    reportDescription: `<p>I report to the trustees on my examination of the accounts of ${this.charityName} (the Charity) for the year ended DD / MM / YYYY. </p>

                        <b>Responsibilities and basis of report</b>
                        <br/>

                        As the charity trustees of the Trust, you are responsible for the preparation of the accounts in accordance with the requirements of the Charities Act 2011 (the Act).

                        I report in respect of my examination of the Trust’s accounts carried out under section 145 of the 2011 Act and in carrying out my examination, I have followed the applicable Directions given by the Charity Commission under section 145(5)(b) of the Act.
                        <br/>

                        <b>Independent examiner's statement</b>
                        <br/>
                        I have completed my examination. I confirm that no material matters have come to my attention (other than that disclosed below *) in connection with the examination which gives me cause to believe that in, any material respect: 
                        <ul>
                        <li> accounting records were not kept in accordance with section 130 of the Act or </l>
                        <li> the accounts do not accord with the accounting records </l>

                        </ul>

                        <p>I have no concerns and have come across no other matters in connection with the examination to which attention should be drawn in order to enable a proper understanding of the accounts to be reached.</p>`


  }

  GetProfessionalAdvisorsDetails() {
    debugger
    /*var charityid = localStorage.getItem('charityId');*/
    var charityid = localStorage.getItem('charityId') || this.charityID;
    this.Charity_Service.getProfessionalAdvisorDetails(charityid).subscribe((data: any) => {
      debugger
      this.ProfessionalAdvisorsDetails = data.entity
      if (data.entity != null) {
        this.ProfessionalAdvisorsDetails_count = this.ProfessionalAdvisorsDetails?.length
        //this.filteredAdvisors1 = this.ProfessionalAdvisorsDetails.filter(
        //  (advisor: { professionalAdvisors_Type: string; }) => advisor.professionalAdvisors_Type === "Examiner"
        //);
        this.filteredAdvisors1 = this.ProfessionalAdvisorsDetails.filter(
          (advisor: { professionalAdvisors_Type: string }) =>
            advisor.professionalAdvisors_Type?.toLowerCase() === "examiner" || advisor.professionalAdvisors_Type?.toLowerCase() === "independent examiner"
        );
        //this.form.controls['reportDescription'].setValue()

      } else {
        this.ProfessionalAdvisorsDetails_count = 0
        //this.DefaultStatement('reportDescription')
      }

    })  
  }
  GetCharityDetails() {
    this.Charities_Service.EditCharityDetails(this.charityID).subscribe((data: any) => {
      debugger
      this.createform()
      this.charityName = data[0].charity_Name
   //   this.endDate = moment(data[0].current_AP_End_Date).format('DD/MM/YYYY');
    
      this.CharithDetails = data[0]
      this.DefaultStatement('reportDescription')
      this.DefaultStatement('responsibilitiesDescription')
      this.DefaultStatement('independentDescription')
      this.GetIndependentExaminerDetails();
    })
  }
  GetIndependentExaminerDetails(): void {
    debugger;

    // const financialPeriodsID = this.form.get('FinancialPeriodsID')?.value;
    this.service.GetIndependentExaminerDetails(this.currentPeriod).subscribe((res: any) => {
      this.createform()
      if (res.entity) {
        // alert('')
        debugger
        console.log('Fetched successfully:', res.entity);

        this.form.patchValue({
          reportDescription: res.entity[0].reportDescription,
          independentDescription: res.entity[0].independentDescription,
          responsibilitiesDescription: res.entity[0].responsibilitiesDescription,
          examinerName: this.filteredAdvisors1[0]?.professionalAdvisors_Name ? this.filteredAdvisors1[0]?.professionalAdvisors_Name:null,
          approvalDate: new Date(res.entity[0].approvalDate),
          accountingBody: res.entity[0].accountingBody,
          CharityID: res.entity[0].charityID,
          FinancialPeriodsID: res.entity[0].financialPeriodsID,
          CreatedDate: new Date(res.entity[0].createdDate),
          Createdby: res.entity[0].createdby,
          Modifiedby: res.entity[0].modifiedby,
          ModifiedDate: new Date(res.entity[0].modifiedDate),
          CentralUserId: res.entity[0].centralUserId,
          UserId: res.entity[0].userId
        });
        this.ischecked = res.entity[0].matter_of_Concern;
      } else {
        this.DefaultStatement('reportDescription')
        this.DefaultStatement('responsibilitiesDescription')
        this.DefaultStatement('independentDescription')
      }
    })

  }
  setVisibility(event: MatRadioChange) {
    debugger
    this.ischecked = event.value == 'Yes';
    this.MarkDirty()
  }
  //Backto previous page--sumit//
  BackToPrevious(event?: any): void {
    if (event) {
      event.preventDefault();
    }
    if (this.isDuirty()) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5>
             <p class="f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px">
               Are you sure you want to leave this page?<br>Data entered will not be saved.
             </p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.isdirty = false;
          this.datashare.setisdirty(false)
          this.form.markAsPristine()
          this.router.navigate(['trusteeannualreport']);
        }
      });
    } else {
      setTimeout(() => {
        this.form.markAsPristine()
        this.router.navigate(['trusteeannualreport']);
      }, 50);
    }
  }



  isDuirty(): any {
    if (this.form.dirty || this.isdirty) {
      return true
    } else { return false }

  }



  backToCharityOverView() {
    debugger

    if (this.isDuirty()) {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.form.markAsPristine()
          this.isdirty = false;
          this.datashare.setisdirty(false)
          localStorage.setItem('isFromBasicInfo', 'true')
          this.router.navigate(['/charity']);
        }
        else {
          // this.spinner.hide()
          return

        }
      })
    }
    else {
      this.form.markAsPristine()
      localStorage.setItem('isFromBasicInfo', 'true')
      this.router.navigate(['/charity']);
    }
  }


  isEditorEmpty(): boolean {
    const html = this.form.get('reportDescription')?.value || '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const plainText = tempDiv.textContent?.trim() || '';
    return plainText.length === 0;
  }

  DbDateConverter(ControllerDate: any) {
    if (ControllerDate) {
      const momentDate = moment(ControllerDate);
      const localMidnight = momentDate.startOf('day');
      const formattedDate = localMidnight.format('YYYY-MM-DDTHH:mm:ss.SS[Z]');
      console.log(formattedDate);
      return formattedDate.toString();
    } else {
      return '';
    }
  }

  validateExaminer(event: any) {
    debugger
    if (event.target.value == null || event.target.value == "") {
      this.form.get('independentExaminerReportId')?.setErrors({ required: true })
      this.form.get('independentExaminerReportId')?.markAsTouched()
    } else {
      this.form.get('independentExaminerReportId')?.setErrors(null)
      this.form.get('independentExaminerReportId')?.markAsPristine()
    }

  }
  onaccounting(event?: any) {
    debugger
    this.accountBodyValue = event.value
    this.DefaultStatement('reportDescription')
    this.DefaultStatement('responsibilitiesDescription')
    this.DefaultStatement('independentDescription')
  }
  
  CurrentDate_Validate(Event?: any) {
    debugger
    const SelectedDate = moment(Event.target.value, 'DD/MM/YYYY', true);
    var CurApStartDate = moment(this.BasicInformation[0].current_AP_Start_Date)
    const isValidDate = SelectedDate.isValid();

    var nextstartdate = moment(new Date(), 'DD/MM/YYYY', true);
    if (Event.target.value != null) {
      if (!isValidDate) {
        this.form.get('approvalDate')?.setErrors({ InvalidDate: true })
      }
      else if (SelectedDate > nextstartdate || SelectedDate < CurApStartDate) {
        this.form.get('approvalDate')?.setErrors({ IsAfterToday: true })
      }
    } else {
      if (!this.form.get('approvalDate')?.errors)
      this.form.get('approvalDate')?.setErrors({ required: true })
    }

  }

  vldExamenirdateofapp(event: any) {
    debugger
    if ((event.target.value == null || event.target.value == "") && !(+this.form.get('approvalDate')?.getRawValue() > 0)) {
      this.form.get('approvalDate')?.setErrors({ required: true })
      this.form.get('approvalDate')?.markAsTouched()
    } else {
      this.form.get('approvalDate')?.setErrors(null)
      this.CurrentDate_Validate(event)

    }

  }

  
  //CurrentDate_Validate1(Event?: any) {
  //  debugger
  //  const SelectedDate = moment(Event.target.value, 'DD/MM/YYYY', true);
  //  var CurApEndDate = moment(localStorage.getItem('CurApEndDate'))
  //  //var _2015 = moment('01-01-2015')
  //  const isValidDate = SelectedDate.isValid();
  //  var SelecteDate = new Date(Event.target.value)
  //  var nextstartdate = new Date()
  //  if (!isValidDate) {
  //    this.form.get('approvalDate')?.setErrors({ InvalidDate: true })
  //  }
  //  else if (SelecteDate > nextstartdate) {
  //    this.form.get('approvalDate')?.setErrors({ IsAfterToday: true })
  //  }
  //  else if (SelectedDate < CurApEndDate) {
  //    this.form.get('approvalDate')?.setErrors({ IsBeforeAP: true })
  //  }

  //}




  enforceMaxLength(event: any): void {
    const input = event.target.value;
    if (input.length > 2500) {
      const trimmed = input.slice(0, 2500);
      event.target.value = trimmed;
      this.form.get('reportDescription')?.setValue(trimmed);
    }
  }



  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    //  ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  CanDeactivate(): any {
    debugger
    if (this.isDuirty()) {
      this.sharedService.updateisLoadingResults(false)
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          debugger
          this.isdirty = false;
          this.datashare.setisdirty(false)
          return true
        } else {
          return false
        }
      })
    } else {
      return true
    }
  }


  UnlockandAmend() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Amend) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Unlocking the accounting period will allow you to amend the filed accounts and correct any errors. After making any changes, the accounts must be submitted again as an Amended filing. Do you want to unlock and amend the accounting period?</p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid).subscribe((data: any) => {
            debugger
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
          })
          //this.save("FinaliseandClose");
        }
        else { }
      })
    }
    else {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  UnfreezeAP() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Do you want to unlock the Accounting Period? </p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid).subscribe((data: any) => {
            debugger
            const message = "Accounting Period unlocked successfully";
            this.msgService.showToastMessage('success', message)
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
          })
        }
      })
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  gotoSubmissions() {
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      this._UsermanagementService.GoToSubmissions()
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }

  }



}
